<template>
    <div>
        <!-- start page title -->
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">FAQs</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a href="/">Pages</a>
                            </li>
                            <li class="breadcrumb-item active">FAQs</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <!-- end page title -->

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4 class="card-title mb-0">All Faqs</h4>
                        <p class="card-title-desc">
                            <a :href="route('admin.cms.faqs.create')" class="btn btn-primary">Add FAQs</a>
                        </p>
                    </div>
                    <div class="card-body">
                        <div class="pb-3">
                            <div class="row">
                                <div class="col-md-3">
                                    <label>Filter Purpose</label>
                                    <select class="form-control form-control-sm"
                                            v-model="purpose"
                                           @change="filter"
                                    >
                                        <option :selected="! purpose || purpose === 'all'" value="all">All</option>
                                        <option :selected="purpose === 'general'" value="general">General</option>
                                        <option :selected="purpose === 'users'" value="users">Users</option>
                                        <option :selected="purpose === 'drivers'" value="drivers">Drivers</option>
                                        <option :selected="purpose === 'fleet_managers'" value="fleet_managers">Fleet Managers</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <table id="datatable-buttons" class="table table-bordered dt-responsive nowrap w-100">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Description</th>
                                    <th>Purpose</th>
                                    <th>Action</th>
                                </tr>
                            </thead>


                            <tbody>
                            <tr v-for="(faq, i) in faqs" :key="faq.id">
                                <td>
                                    {{ ++i }}
                                </td>
                                <td>{{ faq.title }}</td>
                                <td>{{ faq.description.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 100) + '...' }}</td>
                                <td>
                                    <div class="d-flex">
                                        <span
                                            v-for="purpose in faq.purpose"
                                            :key="purpose"
                                            :class="'flex mr-1 badge badge-' + purposeClass(purpose)"
                                        >
                                          {{ purpose }}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <a :href="route('admin.cms.faqs.edit', faq.id)" class="text-primary"><i
                                        class="bx bx-edit-alt"></i> edit</a> |
                                    <a href="#" @click="showAlert(faq.id)" class="text-danger"><i
                                        class="bx bx-trash-alt"></i> delete</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- end cardaa -->
            </div> <!-- end col -->
        </div> <!-- end row -->
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'FAQs'},
    props: ['faqs', 'purpose'],
    layout: Layout,
    methods: {
        showAlert(faqId) {
            let vInstance = this;

            this.$swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    vInstance.deleteFaq(faqId)
                }
            });
        },
        purposeClass(value) {
            if (value === 'general') {
                return "primary";
            } else if (value === 'users')
            {
                return "success";
            } else if (value === 'fleet_managers')
            {
                return "warning";
            } else {
                return "secondary";
            }
        },
        filter () {
            this.$inertia.visit(route('admin.cms.faqs.index', { purpose: this.purpose }))
        },
        deleteFaq(id) {
            this.$inertia.delete(route('admin.cms.faqs.destroy', id));
        }
    }
}
</script>
